/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Each character comes from the Web Crypto API's crypto.getRandomValues(), the cryptographically secure random source browsers use for encryption — not Math.random(), which is predictable and unsuitable for security. Every character is chosen independently with no bias toward any pattern.`)
};

const es_pw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Cada carácter proviene de la Web Crypto API de crypto.getRandomValues(), la fuente de números aleatorios criptográficamente segura que los navegadores utilizan para cifrado — no de Math.random(), que es predecible e inapropiado para seguridad. Cada carácter se elige de forma independiente sin sesgo hacia ningún patrón.`)
};

const de_pw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Jedes Zeichen stammt aus der Web Crypto API crypto.getRandomValues(), der kryptographisch sicheren Zufallsquelle, die Browser für Verschlüsselung verwenden — nicht Math.random(), das vorhersehbar und für Sicherheit ungeeignet ist. Jedes Zeichen wird unabhängig ohne Vorliebe für ein Muster ausgewählt.`)
};

const nl_pw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Elk teken komt uit de Web Crypto API's crypto.getRandomValues(), de cryptografisch veilige willekeurige bron die browsers gebruiken voor versleuteling — niet Math.random(), die voorspelbaar is en ongeschikt voor beveiliging. Elk teken wordt onafhankelijk gekozen zonder voorkeur voor enig patroon.`)
};

const fr_pw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Chaque caractère provient de crypto.getRandomValues() de la Web Crypto API, la source de nombres aléatoires cryptographiquement sécurisée que les navigateurs utilisent pour le chiffrement — pas Math.random(), qui est prévisible et inadapté à la sécurité. Chaque caractère est choisi indépendamment sans aucun biais vers aucun motif.`)
};

const it_pw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Ogni carattere proviene dal Web Crypto API crypto.getRandomValues(), la fonte casuale crittograficamente sicura che i browser utilizzano per la crittografia — non Math.random(), che è prevedibile e inadatto per la sicurezza. Ogni carattere è scelto indipendentemente senza alcuna distorsione verso alcun pattern.`)
};

const pt_br2_pw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Cada caractere vem do crypto.getRandomValues() da Web Crypto API, a fonte aleatória criptograficamente segura que os navegadores usam para criptografia — não do Math.random(), que é previsível e inadequado para segurança. Cada caractere é escolhido independentemente sem viés em relação a qualquer padrão.`)
};

const pt_pw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Cada carácter vem de crypto.getRandomValues() da Web Crypto API, a fonte de número aleatório criptograficamente segura que os navegadores utilizam para encriptação — não Math.random(), que é previsível e inadequado para segurança. Cada carácter é escolhido independentemente sem enviesamento para nenhum padrão.`)
};

const ja_pw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。各文字はWeb Crypto APIのcrypto.getRandomValues()から取得されます。これはブラウザが暗号化に使用する暗号学的に安全なランダムソースです。予測可能で、セキュリティに不適切なMath.random()ではありません。各文字は独立して選択され、パターンへの偏りがありません。`)
};

const zh_pw_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的。每个字符都来自 Web Crypto API 的 crypto.getRandomValues()，这是浏览器用于加密的密码学安全随机数来源——而不是 Math.random()，后者可预测且不适用于安全场景。每个字符都是独立选取的，不偏向任何模式。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pw_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pw_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pw_faq1_a", locale)
	if (locale === "en") return en_pw_faq1_a(inputs)
	if (locale === "es") return es_pw_faq1_a(inputs)
	if (locale === "de") return de_pw_faq1_a(inputs)
	if (locale === "nl") return nl_pw_faq1_a(inputs)
	if (locale === "fr") return fr_pw_faq1_a(inputs)
	if (locale === "it") return it_pw_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_pw_faq1_a(inputs)
	if (locale === "pt") return pt_pw_faq1_a(inputs)
	if (locale === "ja") return ja_pw_faq1_a(inputs)
	return zh_pw_faq1_a(inputs)
};